import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { stagingURL } from "../../views/Apis";
import { axiosBaseQuery } from "../axiosBaseQuery";

export const leagueManagerAPI = createApi({
    reducerPath: "leagueManagerAPI",
    baseQuery: axiosBaseQuery({ baseUrl: stagingURL }),
    endpoints: () => ({}),
});
